// One vocabulary for step display names: the dashboard.tasks step* entries
// (stepAccept, stepStart, ...), shared with the chat task-event rendering
const taskStepLabel = (translate, type, capitalize = true) => translate(
  `step${type[0].toUpperCase()}${type.slice(1)}`,
  'tasks',
  undefined,
  capitalize,
);

export default taskStepLabel;
